import { EHeatingType } from 'shared/json_query';

import { ensureSingleTagExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

const IHeatingTypesTagType = 'advanced-heating';

export interface IHeatingTypesTag {
  type: 'advanced-heating';
  value: EHeatingType;
}

function isHeatingTypesTag(tag: TTag): tag is IHeatingTypesTag {
  return tag.type === IHeatingTypesTagType;
}

export const heatingTypesTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery) => {
    const values = jsonQuery.heating_source_type && jsonQuery.heating_source_type.value;

    let nextTags = tags.filter(
      tag => tag.type !== IHeatingTypesTagType || (values && values.some(value => value === tag.value)),
    );

    if (values !== undefined) {
      nextTags = values.reduce(
        (result, value: EHeatingType) =>
          ensureSingleTagExists(
            result,
            (tag: TTag): tag is IHeatingTypesTag => isHeatingTypesTag(tag) && tag.value === value,
            () => ({ type: IHeatingTypesTagType, value }),
          ),
        nextTags,
      );
    }

    return nextTags;
  },
};
